import { render } from "./VisitsIcon.vue?vue&type=template&id=14f72424"
import script from "./VisitsIcon.vue?vue&type=script&lang=js"
export * from "./VisitsIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__